import { createSlice } from "@reduxjs/toolkit";
import { getPaymentInvoiceData } from "../thunks/paymentThunks";

const invoiceSlice = createSlice({
  name: "invoice",
  initialState: {
    currentInvoiceData: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearInvoiceData: (state) => {
      state.currentInvoiceData = null;
      state.error = null;
    },
    clearInvoiceError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPaymentInvoiceData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPaymentInvoiceData.fulfilled, (state, action) => {
        state.loading = false;
        state.currentInvoiceData = action.payload.data;
        state.error = null;
      })
      .addCase(getPaymentInvoiceData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to fetch invoice data";
      });
  },
});

export const { clearInvoiceData, clearInvoiceError } = invoiceSlice.actions;
export default invoiceSlice.reducer;
